import { Component, computed, inject, signal } from "@angular/core";
import { RightSidebarOptions, RightSidebarService } from "src/services/right-sidebar.service";
import { FilterMode, MarketSalesStateService } from "src/services/estate/market-sales-state.service";
import { EstateFilterBarComponent } from "./estate-filter-bar/estate-filter-bar.component";
import { EstateFilterFieldsComponent } from "./estate-filter-fields/estate-filter-fields.component";

@Component({
    selector: "estate-filter",
    imports: [EstateFilterBarComponent, EstateFilterFieldsComponent],
    templateUrl: "./estate-filter.component.html",
    styleUrl: "./estate-filter.component.scss",
})
export class EstateFilterComponent {
    private readonly rightSidebarService = inject(RightSidebarService);
    private readonly mapStateService = inject(MarketSalesStateService);

    private isStandardFilterMode = computed(
        () => !this.mapStateService.isFavoriteListFilterMode() && this.mapStateService.filterMode() === FilterMode.Standard,
    );

    // Serves both modes: in "Mitt filter" it pulls the working filter back to the standard values
    // without persisting, and in "Basis filter" it resets to hardcoded values.
    showHardResetButton = computed(() => {
        if (this.mapStateService.isFavoriteListFilterMode()) return false;
        if (this.isStandardFilterMode()) return this.mapStateService.isStandardFilterDirty();
        return this.mapStateService.filterMode() === FilterMode.User && this.mapStateService.isDirty();
    });

    // The bar stays put while the fields scroll under it, so it needs a divider to sit against once
    // there is content hidden above the fold.
    readonly isFieldListScrolled = signal(false);

    onCloseFilter(): void {
        this.rightSidebarService.toggleSidebarVisibility(RightSidebarOptions.Filter);
    }

    onResetToStandardFilter(): void {
        if (this.isStandardFilterMode()) {
            this.mapStateService.undoStandardFilter();
            return;
        }
        this.mapStateService.resetUserFilterToStandard();
    }
}
